export default interface InvItemDownRel {
    id: number;
    invoiceNo: string;
    invItem: number;
    dpaymItem: number;
    amount: number;
    netto: number;
    vat: number;
}

export const invItemDownRelDefaultProps: InvItemDownRel = {
    id: 1,
    invoiceNo: "",
    invItem: 1,
    dpaymItem: 1,
    amount: 0,
    netto: 0,
    vat: 0,
};

